// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import VueTheMask from 'vue-the-mask'
import money from 'v-money'
import moment from 'moment'
import _ from 'lodash';
import VueLazyload from 'vue-lazyload'

Vue.use(VueTheMask)
Vue.use(money, {
  decimal: ',',
  thousands: '.',
  prefix: 'R$ ',
  precision: 2,
  masked: false
})

Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: 'https://res.cloudinary.com/sirrus/image/upload/v1614611800/delivery/delivery/download_pl5ymc.png',
  error: 'https://res.cloudinary.com/sirrus/image/upload/v1614611800/delivery/delivery/error_huspix.png',
  attempt: 1,
  observer: true,
})


Vue.prototype.momentJs = moment

require('@/assets/css/materialize.css')
require('@/assets/css/style.css')
require('@/assets/css/customizacoes.css')
require('@/assets/js/materialize.js')
require('@/assets/js/init.js')

Vue.use(Vuex)

Vue.config.productionTip = false

const store = new Vuex.Store({
  state: {
    //apiUrl: 'http://localhost:8000/api/',
    // apiUrl:'https://sirruscomercioapi.test/api/',
    // apiUrl:'https://homologacao.sirruscomercio.app/api/',
    apiUrl: 'https://cloud.sirruscomercio.app/api/',
    is_producao: true,
    empresa_url: '',
    empresa: {},
    grupos: [],
    produtosPromocao: [],
    produtosPromocaoBool: false,
    grupoPromocional: {},
    produtos: [],
    produto: {},
    pedido: {
      itens: []
    },
    dias: [],
    empresaVerificada: false,
    imagem_zoom: "",
    cupom_desconto: "",
    cupom_desconto_valor: 0.00
  },
  mutations: {
    empresaVerificada(state, empresaVerificada) {
      state.empresaVerificada = empresaVerificada;
    },
    grupos(state, grupos) {
      state.grupos = grupos;
    },
    produtosPromocao(state, produtosPromocao) {
      state.produtosPromocao = produtosPromocao;
    },
    produtosPromocaoBool(state, produtosPromocaoBool) {
      state.produtosPromocaoBool = produtosPromocaoBool;
    },
    grupoPromocional(state, grupoPromocional) {
      state.grupoPromocional = grupoPromocional;
    },
    dias(state, dias) {
      state.dias = dias;
    },
    empresaUrl(state, empresa_url) {
      state.empresa_url = empresa_url;
    },
    empresa(state, empresa) {

      document.title = "Sirrus Delivery - " + empresa.nome;

      var style = document.getElementById('cssEmpresa');

      if (!style) {
        style = document.createElement('style');
        style.id = 'cssEmpresa';
        style.type = 'text/css';
        document.getElementsByTagName('head')[0].appendChild(style);
      }

      style.innerHTML =
        '.cor-primaria-text { color: ' + empresa.cor_primaria + ' !important; } ' +
        '.cor-primaria-bg { background-color: ' + empresa.cor_primaria + ' !important; } ' +
        '.cor-primaria-border { border-color: ' + empresa.cor_primaria + ' !important; } ' +
        '.cor-primaria-divider { border-color: ' + empresa.cor_primaria + '4d !important; } ' +

        '.character-counter { color: ' + empresa.cor_primaria + ' !important; } ' +

        'input:not([type]):focus:not([readonly]), input[type=text]:not(.browser-default):focus:not([readonly]), input[type=password]:not(.browser-default):focus:not([readonly]), input[type=email]:not(.browser-default):focus:not([readonly]), input[type=url]:not(.browser-default):focus:not([readonly]), input[type=time]:not(.browser-default):focus:not([readonly]), input[type=date]:not(.browser-default):focus:not([readonly]), input[type=datetime]:not(.browser-default):focus:not([readonly]), input[type=datetime-local]:not(.browser-default):focus:not([readonly]), input[type=tel]:not(.browser-default):focus:not([readonly]), input[type=number]:not(.browser-default):focus:not([readonly]), input[type=search]:not(.browser-default):focus:not([readonly]), textarea.materialize-textarea:focus:not([readonly]) { border-bottom: 1px solid ' + empresa.cor_primaria + ' !important; -webkit-box-shadow: 0 1px 0 0 ' + empresa.cor_primaria + ' !important; box-shadow: 0 1px 0 0 ' + empresa.cor_primaria + ' !important; } ' +

        '[type="checkbox"].filled-in:not(:checked) + span:not(.lever):after { border-color: ' + empresa.cor_primaria + ' !important; } ' +
        '[type="checkbox"].filled-in:checked + span:not(.lever):after { background-color: ' + empresa.cor_primaria + ' !important; border-color: ' + empresa.cor_primaria + ' !important; } ' +
        '.switch label input[type=checkbox]:checked + .lever { background-color: ' + empresa.cor_primaria + '99 !important; } ' +
        '.switch label .lever:before { background-color: ' + empresa.cor_primaria + '26 !important; } ' +
        '.switch label input[type=checkbox]:checked + .lever:after { background-color: ' + empresa.cor_primaria + ' !important; } ' +

        '[type="radio"]:not(:checked) + span:before, [type="radio"]:not(:checked) + span:after { border: 2px solid ' + empresa.cor_primaria + ' !important; } ' +
        '[type="radio"]:checked + span:after, [type="radio"].with-gap:checked + span:after { background-color: ' + empresa.cor_primaria + ' !important; } ' +
        '[type="radio"]:checked + span:after, [type="radio"].with-gap:checked + span:before, [type="radio"].with-gap:checked + span:after { border: 2px solid ' + empresa.cor_primaria + ' !important; } ' +

        '.cor-secundaria-bg { background-color: ' + empresa.cor_secundaria + ' !important; } ' +

        '.cor-fonte-menu-lateral { color: ' + empresa.cor_cardapio_menu_fonte + ' !important; } ' +
        '.splash-cor-1 { color: ' + empresa.cor_splash_texto_1 + ' !important; } ' +
        '.splash-cor-2 { color: ' + empresa.cor_splash_texto_2 + ' !important; }';

      state.empresa = empresa;
    },
    produtos(state, produtos) {
      state.produtos = produtos;
    },
    produto(state, produto) {
      state.produto = produto;
    },
    pedido(state, pedido) {
      state.pedido = pedido;
    },
    adicionar_item_pedido(state, item) {
      state.pedido.itens.push(item);
    },
    imagem_zoom(state, imagem_zoom) {
      state.imagem_zoom = imagem_zoom;
    },
    remover_item_pedido(state, itemRemover) {
      var forDeletion = [];
      forDeletion.push(itemRemover);
      var itenspedido = state.pedido.itens.filter(item => !forDeletion.includes(item))
      state.pedido.itens = itenspedido;
    },
    remover_item_adicional_pedido(state, objetoItemAdicional) {
      var forDeletion = [];
      forDeletion.push(objetoItemAdicional.adicional);

      var itenspedido = objetoItemAdicional.item.adicionais.filter(item => !forDeletion.includes(item));
      objetoItemAdicional.item.adicionais = itenspedido;

      const index = state.pedido.itens.findIndex(project => project === objetoItemAdicional.item);
      state.pedido.itens[index] = objetoItemAdicional.item;
    }
  },
  getters: {
    getPesoTotalPedido: state => {

      var valorTotal = 0.000;
      state.pedido.itens.forEach(res => {
        var valorAdicional = 0.000;
        // res.adicionais.forEach( adicional=>{
        //   if(adicional){
        //     valorAdicional = parseFloat(valorAdicional) + parseFloat(adicional.valor) * (adicional.quantidade || 1);
        //   }
        // })
        valorTotal = valorTotal + ((parseFloat(res.produto.peso) + valorAdicional) * res.quantidade);
      });
      return valorTotal.toFixed(3);

    },
    getValorTotalPedido: state => {

      var valorTotal = 0.00;
      state.pedido.itens.forEach(res => {
        var valorAdicional = 0.00;
        res.adicionais.forEach(adicional => {
          if (adicional) {
            valorAdicional = parseFloat(valorAdicional) + parseFloat(adicional.valor) * (adicional.quantidade || 1);
          }
        })
        valorTotal = valorTotal + ((parseFloat(res.produto.valor) + valorAdicional) * res.quantidade);
      });
      valorTotal = valorTotal - state.cupom_desconto_valor;
      return valorTotal.toFixed(2);

    },
    pedidoSubtotal: state => {
      var subtotal = 0.00;
      state.pedido.itens.forEach(res => {
        var valorAdicional = 0.00;
        res.adicionais.forEach(adicional => {
          if (adicional) {
            valorAdicional += parseFloat(adicional.valor) * (adicional.quantidade || 1);
          }
        });

        subtotal += (parseFloat(res.produto.valor) + valorAdicional) * res.quantidade;
      });
      return subtotal;
      // return subtotal - state.cupom_desconto_valor;
    },
    pedidoTotal: (state, getters) => {
      return parseFloat(getters.pedidoSubtotal + parseFloat(state.empresa.taxa_entrega) - parseFloat(state.cupom_desconto_valor)).toFixed(2);
    }

  }
});

Vue.prototype.$store = store;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js